import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=032bf628&scoped=true&"
import script from "./Pause.vue?vue&type=script&lang=js&"
export * from "./Pause.vue?vue&type=script&lang=js&"
import style0 from "./Pause.vue?vue&type=style&index=0&id=032bf628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032bf628",
  null
  
)

export default component.exports